import { IconCirclePlus } from '@tabler/icons-react'
import { Dropdown, DropdownOption } from 'components/Dropdown'
import { UploadFile } from 'components/UploadFile'
import { UploadRSS } from 'components/UploadRSS'
import { UploadYouTube } from 'components/UploadYouTube'
import { useState } from 'react'
import { UploadMethod } from 'store/useStore'

export const Upload = ({
  projectId,
  onUpload,
}: {
  projectId?: number
  onUpload?: (data: any) => void
}) => {
  const [type, setType] = useState<UploadMethod>('youtube')

  const options: DropdownOption<UploadMethod>[] = [
    { id: 'youtube', label: 'Import by URL', value: 'youtube' },
    {
      id: 'upload',
      label: 'Import video or audio file',
      value: 'upload',
    },
    { id: 'rss', label: 'Import from RSS', value: 'rss' },
  ]

  const handleTypeChange = (type: UploadMethod) => {
    setType(type)
  }

  const handleUpload = (data: any) => {
    onUpload?.(data)
  }

  const selectedOption = options.find((option) => option.value === type)!

  return (
    <div className="mt-8 flex w-full flex-col items-start justify-start gap-y-8 rounded-lg">
      <Dropdown
        icon={<IconCirclePlus className="h-4 w-4" />}
        className="w-fit"
        options={options}
        setValue={(option) => handleTypeChange(option.value)}
        value={selectedOption}
      />
      {type === 'rss' && <UploadRSS onUpload={handleUpload} />}
      {type === 'youtube' && <UploadYouTube onUpload={handleUpload} />}
      {type === 'upload' && (
        <UploadFile projectId={projectId} onUpload={handleUpload} />
      )}
    </div>
  )
}
